



















import Vue from 'vue'
import { Item2ColTextInterface } from '@/config/interfaces'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'Item2ColText',
  props: {
    templateItemData: {
      type: Object as () => Item2ColTextInterface,
      required: true
    }
  },
  computed: {
    fontSize (): string {
      let size: string
      switch (this.$props.templateItemData.size) {
        case 'large':
          size = '1.1rem'
          break
        case 'medium':
          size = '1.05rem'
          break
        default:
          size = '1rem'
          break
      }
      return `font-size: ${size};`
    },
    getText1Color (): string {
      return `color: ${this.$props.templateItemData.text1color || (this.$vuetify.theme.dark
        ? darkColors.textColor : lightColors.primary)};`
    },
    getText2Color (): string {
      return `color: ${this.$props.templateItemData.text2color || (this.$vuetify.theme.dark
        ? darkColors.textColor : lightColors.primary)};`
    },
    getText1Weight (): string {
      return `font-weight: ${this.$props.templateItemData.text1weight || 'normal'};`
    },
    getText2Weight (): string {
      return `font-weight: ${this.$props.templateItemData.text2weight || 'normal'};`
    }
  }
})
